import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './contactus.css'

const Contactus = (props) => {
  return (
    <div id={props.contactUsId} className="thq-section-padding scroll-target">
      <div className="contactus-thq-max-width-elm thq-section-max-width">
        <div className="contactus-thq-section-title-elm">
          <div className="contactus-thq-content-elm1">
            <h2 className="thq-heading-2">
              {props.heading1 ?? (
                <Fragment>
                  <span className="contactus-text4">Prop Content</span>
                </Fragment>
              )}
            </h2>
            <p className="thq-body-large">
              {props.content2 ?? (
                <Fragment>
                  <span className="contactus-text6">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                </Fragment>
              )}
            </p>
          </div>
        </div>
        <div className="contactus-thq-row-elm">
          <div className="contactus-thq-content-elm2">
            <svg viewBox="0 0 1024 1024" className="thq-icon-medium">
              <path d="M854 342v-86l-342 214-342-214v86l342 212zM854 170q34 0 59 26t25 60v512q0 34-25 60t-59 26h-684q-34 0-59-26t-25-60v-512q0-34 25-60t59-26h684z"></path>
            </svg>
            <div className="contactus-thq-contact-info-elm1">
              <div className="contactus-thq-content-elm3">
                <h3 className="contactus-thq-text-elm3 thq-heading-3">Email</h3>
                <p className="contactus-thq-text-elm4 thq-body-large">
                  {props.content3 ?? (
                    <Fragment>
                      <span className="contactus-text5">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Suspendisse varius enim in ero.
                      </span>
                    </Fragment>
                  )}
                </p>
              </div>
              <a
                href="mailto:info@evac.vn.ua?subject=Business request for cooperation with Evac"
                className="contactus-thq-email-elm thq-body-small"
              >
                {props.email1 ?? (
                  <Fragment>
                    <span className="contactus-text3">info@evac.com.ua</span>
                  </Fragment>
                )}
              </a>
            </div>
          </div>
          <div className="contactus-thq-content-elm4">
            <svg viewBox="0 0 1024 1024" className="thq-icon-medium">
              <path d="M282 460q96 186 282 282l94-94q20-20 44-10 72 24 152 24 18 0 30 12t12 30v150q0 18-12 30t-30 12q-300 0-513-213t-213-513q0-18 12-30t30-12h150q18 0 30 12t12 30q0 80 24 152 8 26-10 44z"></path>
            </svg>
            <div className="contactus-thq-contact-info-elm2">
              <div className="contactus-thq-content-elm5">
                <h3 className="contactus-thq-text-elm5 thq-heading-3">
                  Телефон
                </h3>
                <p className="contactus-thq-text-elm6 thq-body-large">
                  {props.content5 ?? (
                    <Fragment>
                      <span className="contactus-text1">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Suspendisse varius enim in ero.
                      </span>
                    </Fragment>
                  )}
                </p>
              </div>
              <a
                href="tel:+380977316850"
                className="contactus-thq-phone-elm1 thq-body-small"
              >
                {props.phone1 ?? (
                  <Fragment>
                    <span className="contactus-text7">123-456-7890</span>
                  </Fragment>
                )}
              </a>
              <a
                href="tel:+380932979737"
                className="contactus-thq-phone-elm2 thq-body-small"
              >
                {props.phone11 ?? (
                  <Fragment>
                    <span className="contactus-text2">123-456-7890</span>
                  </Fragment>
                )}
              </a>
            </div>
          </div>
          <a
            href="https://maps.app.goo.gl/zap2E1F2MfhoKEz66?g_st=atm"
            target="_blank"
            rel="noreferrer noopener"
            className="contactus-link"
          >
            <div className="contactus-thq-content-elm6">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                className="thq-icon-medium"
              >
                <path
                  d="M18.27 6c1.01 2.17.78 4.73-.33 6.81c-.94 1.69-2.29 3.12-3.44 4.69c-.5.7-1 1.45-1.37 2.26c-.13.27-.22.55-.32.83s-.19.56-.28.84c-.09.26-.2.57-.53.57c-.39 0-.5-.44-.58-.74c-.24-.73-.48-1.43-.85-2.1c-.42-.79-.95-1.52-1.49-2.23zM9.12 8.42l-3.3 3.92c.61 1.29 1.52 2.39 2.39 3.49c.21.25.42.51.62.78L13 11.67l-.04.01c-1.46.5-3.08-.24-3.66-1.68c-.08-.17-.14-.37-.18-.57a3 3 0 0 1 0-1zm-2.54-3.8l-.01.01c-1.62 2.05-1.9 4.9-.93 7.31L9.63 7.2l-.05-.05zm7.64-2.26L11 6.17l.04-.01c1.34-.46 2.84.12 3.52 1.34c.15.28.27.58.31.88c.06.38.08.65.01 1.02v.01l3.2-3.8a7 7 0 0 0-3.85-3.24zM9.89 6.89l3.91-4.65l-.04-.01C13.18 2.08 12.59 2 12 2c-1.97 0-3.83.85-5.15 2.31l-.02.01z"
                  fill="currentColor"
                ></path>
              </svg>
              <div className="contactus-thq-contact-info-elm3">
                <div className="contactus-thq-content-elm7">
                  <h3 className="contactus-thq-text-elm7 thq-heading-3">
                    Офіс
                  </h3>
                </div>
              </div>
              <span className="contactus-thq-phone-elm3 thq-body-small">
                Вінниця, Вінницька обл. 21000, Україна
              </span>
            </div>
          </a>
        </div>
      </div>
    </div>
  )
}

Contactus.defaultProps = {
  content5: undefined,
  phone11: undefined,
  email1: undefined,
  heading1: undefined,
  content3: undefined,
  content2: undefined,
  contactUsId: '',
  rootClassName: '',
  phone1: undefined,
}

Contactus.propTypes = {
  content5: PropTypes.element,
  phone11: PropTypes.element,
  email1: PropTypes.element,
  heading1: PropTypes.element,
  content3: PropTypes.element,
  content2: PropTypes.element,
  contactUsId: PropTypes.string,
  rootClassName: PropTypes.string,
  phone1: PropTypes.element,
}

export default Contactus
